(() => {
  const script = document.querySelector('script[data-islander-growthbook]');
  if (!script || window.Shopify?.designMode) return;
  const DEBUG = true; // Temporary experiment validation; set false after checking DebugView.
  const workshopRoot = document.querySelector('[data-workshop-experiment]');
  const workshopOwnsSDK = workshopRoot?.dataset?.productionEnabled === 'true' && workshopRoot.dataset.themeRole?.toLowerCase() === 'main';

  let loaded = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const start = () => {
    // The workshop loads one cookieless SDK for presentation; consent still gates tracking.
    if (loaded || (!workshopOwnsSDK && !allowed())) return;
    loaded = true;
    window.growthbook_config = window.growthbook_config || {};
    window.growthbook_config.trackingCallback = (experiment, result) => {
      // Delivery owns exposure after its visible message and checkout policy agree.
      if (experiment.key === 'free-uk-delivery-amount-bar') return;
      if (!allowed()) return;
      // The workshop page publishes its exposure after the selected page has rendered.
      if (experiment.key === 'new-workshop-page' && document.querySelector('[data-workshop-experiment]')) return;
      try {
        window.Shopify?.analytics?.publish?.('islander:interaction', {
          event_name: 'experiment_viewed',
          experiment_id: experiment.key,
          variation_id: result.key,
          debug_mode: DEBUG && experiment.key === 'make-your-bag-1st-test',
        })?.catch?.(() => {});
      } catch {}
    };

    window.growthbook_queue = window.growthbook_queue || [];
    window.growthbook_queue.push((gb) => {
      // The page experiment owns its hero labels and FareHarbor references.
      if (document.querySelector('[data-workshop-experiment]')) return;
      const controls = [...document.querySelectorAll('a.islander-home-workshop__button, .islander-workshop-hero a.button--primary, a.islander-workshop-booking')]
        .filter((original) => original.dataset?.islanderWorkshopPageLink !== 'true')
        .map((original) => ({ original }));
      if (!controls.length && !document.querySelector('a[href*="fareharbor.com/embeds/book/islanderuk/"]')) return;
      let bookingRef;
      const taggedLinks = new Map();
      const updateBookingLinks = () => {
        // Remove only our own reference; keep existing referrals and linker parameters.
        const links = new Set([...document.querySelectorAll('a[href*="fareharbor.com/embeds/book/"]'), ...taggedLinks.keys()]);
        links.forEach((link) => {
          let url;
          try { url = new URL(link.href, location.origin); } catch { return; }
          const previousRef = taggedLinks.get(link);
          if (previousRef && url.searchParams.get('ref') === previousRef) url.searchParams.delete('ref');
          taggedLinks.delete(link);
          if (bookingRef && url.hostname === 'fareharbor.com' && url.pathname.startsWith('/embeds/book/islanderuk/') && !url.searchParams.has('ref')) {
            url.searchParams.set('ref', bookingRef);
            taggedLinks.set(link, bookingRef);
          }
          if (previousRef || taggedLinks.has(link)) link.href = url.href;
        });
      };
      const onWorkshopPage = /\/pages\/islander-workshop-experience\/?$/.test(location.pathname);
      const setLabel = (element, label) => {
        // Keep the homepage arrow and booking link's screen-reader annotation.
        const text = [...element.childNodes].find((node) => node.nodeType === 3 && node.textContent.trim());
        if (text) text.textContent = label;
      };
      controls.forEach(({ original }) => original.setAttribute('data-islander-experiment-debug', String(DEBUG)));
      const apply = () => {
        const feature = allowed() ? gb.evalFeature('ab_test_workshop_button') : null;
        const changed = !!feature?.on;
        const assignment = feature?.experimentResult;
        const option = ['A', 'B'][assignment?.variationId];
        bookingRef = feature?.source === 'experiment' && feature.experiment?.active !== false && assignment?.inExperiment && option && feature.experiment?.key
          ? `${feature.experiment.key}_option${option}` : undefined;
        controls.forEach((control) => {
          const { original } = control;
          setLabel(original, 'Book Workshop');
          if (onWorkshopPage) {
            // Visitors are already exploring workshops: keep booking available.
            setLabel(original, changed ? 'Make Your Own Bag!' : 'Book Workshop');
            original.setAttribute('aria-label', changed ? 'Make your own bag: book an Islander workshop' : 'Book an Islander workshop experience');
          } else if (changed && !control.replacement) {
            const replacement = original.cloneNode(true);
            replacement.removeAttribute('onclick');
            replacement.removeAttribute('data-fareharbor-src');
            replacement.removeAttribute('target');
            replacement.querySelector('.visually-hidden')?.remove();
            setLabel(replacement, 'Make Your Own Bag!');
            replacement.setAttribute('aria-label', 'Make your own bag: explore Islander workshops');
            const destination = (window.Shopify.routes?.root || '/') + 'pages/islander-workshop-experience';
            replacement.href = window.IslanderWorkshopNavigation?.decorateURL(destination) || destination;
            original.replaceWith(replacement);
            control.replacement = replacement;
          } else if (!changed && control.replacement) {
            control.replacement.replaceWith(original);
            control.replacement = undefined;
          }
        });
        updateBookingLinks();
        const attribution = window.IslanderExperimentAttribution;
        const features = gb.getFeatures?.();
        if (features) attribution?.configure(features);
        if (controls.some(({ original, replacement }) => (replacement || original).isConnected)) {
          attribution?.record(feature, {
            phase: attribution.phaseFor(features, 'ab_test_workshop_button', feature?.experiment?.key),
            renderedValue: changed,
          });
        }
      };
      apply();
      document.addEventListener('growthbookdata', apply);
      document.addEventListener('visitorConsentCollected', apply);
      // Also cover links inserted after the SDK starts, before FareHarbor handles navigation.
      ['click', 'auxclick', 'contextmenu'].forEach((name) => document.addEventListener(name, updateBookingLinks, true));
    });

    if (workshopOwnsSDK) return;
    const sdk = document.createElement('script');
    sdk.async = true;
    sdk.dataset.apiHost = 'https://cdn.growthbook.io';
    sdk.dataset.clientKey = script.dataset.clientKey;
    sdk.src = 'https://cdn.jsdelivr.net/npm/@growthbook/growthbook/dist/bundles/auto.min.js';
    document.head.appendChild(sdk);
  };

  start();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) start(); });
  }
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', start);
  document.addEventListener('visitorConsentCollected', start);
})();
